export function maxMenuWidthForMultiselect (showHoverCard) {
    // 400px is default max menu width for pendo-multiselect
    // 720px is 400px + width of hover card (320px)
    return showHoverCard ? 720 : 400;
}

export function flattenOptions (options) {
    // Return empty array if options is null or undefined
    if (!options) return [];

    // Return empty array if options are empty, could be an array of empty arrays
    const isEmpty = options.every((item) => Array.isArray(item) && item.length === 0);
    if (isEmpty) return [];

    // Return options if they are already flat (no 'options' or 'list' property in any object
    const isFlat = options.every((item) => !item.options && !item.list);
    if (isFlat) {
        return options;
    }

    // Flatten the 'options' or 'list' arrays
    return options.reduce((acc, item) => {
        if (item.options && Array.isArray(item.options)) {
            return acc.concat(item.options);
        }
        if (item.list && Array.isArray(item.list)) {
            return acc.concat(item.list);
        }

        return acc;
    }, []);
}
